import {createReducer} from '@reduxjs/toolkit';
import {
  clear,
  selectReserveFeatureRefs,
  selectReleaseFeatureRefs,
  selectReserveProduct,
  selectReleaseProduct,
  setMode,
} from '@src/actions/quotaManagement.ts';
import {type FeatureRef} from '@src/types/featureCollections.ts';
import {type Product} from '@src/types/products.ts';

type QuotaManagementState = {
  mode: 'reserve' | 'release';
  reserve: {
    selectedFeatureRefs: FeatureRef[];
    selectedProduct: Product | null;
  };
  release: {
    selectedFeatureRefs: FeatureRef[];
    selectedProduct: Product | null;
  };
};

export const initialState: QuotaManagementState = {
  mode: 'reserve',
  reserve: {
    selectedFeatureRefs: [],
    selectedProduct: null,
  },
  release: {
    selectedFeatureRefs: [],
    selectedProduct: null,
  },
};

export default createReducer(initialState, builder => {
  builder.addCase(clear, state => {
    state.reserve.selectedFeatureRefs = [];
    state.reserve.selectedProduct = null;
    state.release.selectedFeatureRefs = [];
    state.release.selectedProduct = null;
  });

  builder.addCase(selectReserveFeatureRefs, (state, {payload}) => {
    state.reserve.selectedFeatureRefs = payload ?? [];
  });

  builder.addCase(selectReleaseFeatureRefs, (state, {payload}) => {
    state.release.selectedFeatureRefs = payload ?? [];
  });

  builder.addCase(selectReserveProduct, (state, {payload}) => {
    state.reserve.selectedProduct = payload ?? null;
  });

  builder.addCase(selectReleaseProduct, (state, {payload}) => {
    state.release.selectedProduct = payload ?? null;
  });

  builder.addCase(setMode, (state, {payload}) => {
    state.mode = payload;
  });
});
